import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import PageShell from './PageShell';
import Seo from '../components/Seo';
import { useI18n } from '../context/I18nContext';
import { publicApi } from '../api';
import { useApi } from '../hooks/useApi';
import { Spinner } from '../components/StateHelpers';

export default function GenericPage({ slug: propSlug }) {
  const { slug: paramsSlug } = useParams();
  const location = useLocation();
  const { lang } = useI18n();

  const pageSlug = propSlug || paramsSlug || location.pathname.replace(/^\/pages\//, '').replace(/^\//, '');
  const { data: p, loading } = useApi(() => publicApi.page(pageSlug, lang), [pageSlug, lang]);
  useEffect(() => { if (p) document.title = (p.meta_title || p.title) + ' — Aegis Studios'; }, [p]);

  const page = p || { title: 'Sayfa Bulunamadı', content: '<p>Bu sayfa henüz oluşturulmamış.</p>' };

  return (
    <PageShell eyebrow="SAYFA" title={<span className="gold-text">{page.title}</span>}>
      <Seo title={page.meta_title || page.title} description={page.meta_description} />
      <section className="pb-24">
        <div className="max-w-[1000px] mx-auto px-4 md:px-6 lg:px-10">
          {loading ? <Spinner /> : (
            <article className="prose prose-invert prose-p:text-white/75 prose-headings:text-white prose-h2:font-display prose-strong:text-white prose-a:text-[#f4d896] max-w-none"
              dangerouslySetInnerHTML={{ __html: page.content }} />
          )}
        </div>
      </section>
    </PageShell>
  );
}
